/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} World_Switcher_UnknownInputs */

const en_world_switcher_unknown = /** @type {(inputs: World_Switcher_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_world_switcher_unknown = /** @type {(inputs: World_Switcher_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const ms_sg2_world_switcher_unknown = /** @type {(inputs: World_Switcher_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak diketahui`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {World_Switcher_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_unknown = /** @type {((inputs?: World_Switcher_UnknownInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_UnknownInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_unknown(inputs)
	if (locale === "fr") return fr_world_switcher_unknown(inputs)
	return ms_sg2_world_switcher_unknown(inputs)
});